/**
 * Build a workspace-scoped path: `/w/<slug>/…`. Pure and slug-explicit, so the
 * cross-workspace entry pages (Overview, Projects, Prototypes) — which render
 * outside any `/w/:slug` route — can link each item into ITS OWN workspace
 * rather than the currently-active one.
 *
 * `workspacePath('acme', '/projects/RV')` -> `/w/acme/projects/RV`
 * `workspacePath('acme', '/')` -> `/w/acme`
 *
 * An empty slug returns the path unchanged (identity), matching how
 * useWorkspacePath behaves with no workspace in scope.
 */
export function workspacePath(slug: string, path: string): string {
  if (!slug) return path;
  const base = `/w/${slug}`;
  if (!path || path === '/') return base;
  return `${base}${path.startsWith('/') ? path : `/${path}`}`;
}
